import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPOS } from "../../../config/api";

export const createIpo = createAsyncThunk(
  "ipos/create",
  async ({ data, navigate, setSubmitting }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPOS,
        data,
      });
      toast.success("IPO created successfully");
      const createdId = response?.data?.data?.ipo?.id;
      navigate(createdId ? `/ipos/${createdId}` : "/ipos", { replace: true });
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting && setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
